import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import styles from "./PDFPreview.module.scss";
import clsx from "clsx";

export const PDFPreview = ({
  url,
  selected,
}: {
  url: string;
  selected: boolean;
}) => {
  const [activeUrl, setActiveUrl] = useState<string| null>(null);

  useEffect(() => {
    setActiveUrl(url)
  }, [url])

  return (
    <div
      className={clsx(styles.previewViewerWrapper, {
        [styles.selectedPDF]: selected,
      })}
    >
      <Document
        key={`doc_${activeUrl}`}
        file={activeUrl}
      >
        <Page
          pageNumber={1}
          scale={1}
          devicePixelRatio={1}
          renderAnnotationLayer={false}
          className={"pageStyling"}
          renderTextLayer={false}
          width={280}
        />
      </Document>
    </div>
  );
};

export default PDFPreview;
